import React, { useRef } from "react";
import { Table, Input } from "reactstrap";
import { IDataTableProps } from "../../../interfaces/Index";
import "./DataTableProductSearch.scss";

export const parentIDFunc = (id: any, toggleClass: any) => {
  if (id === null) {
    toggleClass.current = !toggleClass.current;
  }
  return toggleClass.current ? "with-sub-category" : "without-sub-category";
};

export const generateBodyRowClassName = (
  tableId: string,
  id: any,
  toggleClass: any,
  itemData: any
) => {
  let classes = parentIDFunc(id, toggleClass);

  if (tableId === "product-list") {
    // Check item stock and add disable class if stock is out
    classes += " out-of-stock-product";
  }
  return `${classes}`;
};

export const checkDisabled = (tableId: string, data: any) => {
  if (tableId === "product-list") {
    // Check item stock and add disable class if stock is out
    return true;
  }
  return false;
};

export const renderTableText = (tableId: string, data: any, dataType: any) => {
  if (tableId === "product-list" && dataType.key === "itemPrice") {
    // Check item stock and add disable class if stock is out
    return "Item not available";
  } else {
    const dataValue =
      data[dataType.key] && data[dataType.key] === 0
        ? 0
        : data[dataType.key] !== undefined
        ? data[dataType.key]
        : "";

    return `${dataType.prepend || ""} ${dataValue}`;
  }
};

const DataTableProductSearch: React.FunctionComponent<IDataTableProps> = (
  props: IDataTableProps
) => {
  let toggleClass: any = useRef(true);

  const renderTableHeaders = () => {
    const {
      handleAllRecordSelection,
      tableHeaderData,
      allRecordsChecked,
    } = props;
    return tableHeaderData?.map((header, index) => {
      if (header.type === "checkbox") {
        return (
          <th key={index}>
            <Input
              type={header.type}
              checked={allRecordsChecked}
              onClick={handleAllRecordSelection}
            />
          </th>
        );
      }
      return <th key={index}>{header.text}</th>;
    });
  };

  const renderTableData = (data: any, index: number) => {
    const { tableBodyDataTypes, checkBoxClickHandler, tableId } = props;
    return tableBodyDataTypes.map((dataType, i) => {
      if (dataType.type === "checkbox") {
        return (
          <td key={i}>
            <Input
              key={index}
              type={dataType.type}
              checked={data[dataType.key]}
              onClick={(e) => checkBoxClickHandler?.(e, index)}
              // disabled={checkDisabled(tableId as string, data)}
            />
          </td>
        );
      } else if (dataType.key === "itemPrice") {
        return data["itemPrice"] > 0 ? (
          <td key={i} title={data[dataType.key]} className="hide-price">
            <div className="slash-price">
              {dataType.prepend}
              {data["productOriginalPrice"]}
            </div>
            <div className="product-original-price">
              {dataType.prepend}
              {data[dataType.key]}
            </div>
            <div className="item-not-available">Item not available</div>
          </td>
        ) : (
          <td
            key={i}
            title={data["productOriginalPrice"]}
            className="hide-price"
          >
            <div className="product-original-price">
              {dataType.prepend}
              {data["productOriginalPrice"]}
            </div>
            <div className="item-not-available">Item not available</div>
          </td>
        );
      }
      return (
        <td
          key={i}
          title={data[dataType.key]}
          // className={"disable-product-out-of-stock"}
        >
          {/* {renderTableText(tableId as string, data, dataType)} */}
          {dataType.prepend}
          {data[dataType.key]}
        </td>
      );
    });
  };

  const renderTableBody = () => {
    const {
      editRowHandler,
      tableBodyRowData,
      tableBodyDataTypes,
      tableId,
    } = props;
    return tableBodyRowData.map((item, index) => {
      return (
        <tr
          key={index}
          // className={
          //   generateBodyRowClassName(
          //     tableId as string,
          //     item.parentId,
          //     toggleClass,
          //     item
          //   ) || (item.isChecked ? "record-selected" : "")
          // }
          className={
            (item.stock > 0 ? "stock-available" : "stock-unavailable") ||
            parentIDFunc(item.parentId, toggleClass) ||
            (item.isChecked ? "record-selected" : "")
          }
          onClick={(e) => editRowHandler?.(e, index)}
        >
          {tableBodyDataTypes &&
            tableBodyDataTypes.length > 0 &&
            renderTableData(item, index)}
        </tr>
      );
    });
  };

  const renderTableFooter = () => {
    const { tableFooterData, noSearchResultFlag, tableBodyRowData } = props;
    return (
      noSearchResultFlag &&
      tableBodyRowData &&
      tableBodyRowData.length === 0 && (
        <tr>
          <div className="no-search-found">
            <img src={tableFooterData?.imgSrc} alt={tableFooterData?.imgAlt} />
            <div className="no-search-title">{tableFooterData?.title}</div>
            <div className="no-search-sub-title">
              {tableFooterData?.subTtitle}
            </div>
          </div>
        </tr>
      )
    );
  };

  return (
    <Table borderless striped className="table" id={props.tableId}>
      {props.tableHeaderData && props.tableHeaderData.length > 0 && (
        <thead>
          <tr>{renderTableHeaders()}</tr>
        </thead>
      )}
      <tbody>
        {props.tableBodyRowData &&
          props.tableBodyRowData.length > 0 &&
          renderTableBody()}
      </tbody>
      {props.tableFooterData && (
        <tfoot>
          <tr>{renderTableFooter()}</tr>
        </tfoot>
      )}
    </Table>
  );
};

DataTableProductSearch.defaultProps = {
  tableId: "tableId",
  tableHeaderData: null,
  tableFooterData: null,
  noSearchResultFlag: false,
  allRecordsChecked: false,
};

export default DataTableProductSearch;
